import * as React from 'react';

function CheckIcon() {
    return (
        <svg width='1em' height='1em' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M1 7l6 6L17 1' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

export default CheckIcon;
